var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.24 22.56C11 22.88 11.04 23.2 11.48 23.44C12.96 24.32 13.64 27.28 13.64 29.08C13.64 33.2 12.12 35.84 7.8 35.84C3.92 35.84 2.04 32.36 2.04 26.4C2.04 16.16 7.32 11.32 12.6 11.32C15.92 11.32 18.08 13 19.32 16.16C20.6 12.88 22.48 11.32 26.92 11.32C32.48 11.32 36.68 16.56 36.68 26.2C36.68 32.68 35 35.84 30.72 35.84C27.4 35.84 26.2 34.04 26.04 29.96C25.88 24.92 24.84 22.92 23.16 22.04C22.72 21.8 22.4 21.88 22.24 22.16C22.12 22.48 22.24 22.8 22.44 22.96C24 23.96 24.6 26.16 24.64 28.92C24.68 33.2 23.32 35.84 19.96 35.84C16 35.84 14.96 33.44 14.84 29.36C14.72 25.84 13.84 23.4 12.08 22.44C11.76 22.24 11.4 22.28 11.24 22.56Z",
    fill: "#0094FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1554 29.7375C28.9482 29.647 28.9482 29.353 29.1554 29.2625L31.2247 28.3584C31.2845 28.3323 31.3323 28.2845 31.3584 28.2247L32.2625 26.1554C32.353 25.9482 32.647 25.9482 32.7375 26.1554L33.6416 28.2247C33.6677 28.2845 33.7155 28.3323 33.7753 28.3584L35.8446 29.2625C36.0518 29.353 36.0518 29.647 35.8446 29.7375L33.7753 30.6416C33.7155 30.6677 33.6677 30.7155 33.6416 30.7753L32.7375 32.8446C32.647 33.0518 32.353 33.0518 32.2625 32.8446L31.3584 30.7753C31.3323 30.7155 31.2845 30.6677 31.2247 30.6416L29.1554 29.7375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.b7066d909a855afd7f34d57fcfab49f6.svg";
export { ForwardRef as ReactComponent };